import "./WeatherDataDisplay.css"

const WeatherDataDisplay = ({ weatherData, loading, error }) => {
  if (loading) {
    return (
      <div className="weather-loading">
        <div className="spinner"></div>
        <p>Loading weather data...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="weather-error">
        <i className="fas fa-exclamation-circle"></i>
        <p>{error}</p>
      </div>
    )
  }

  if (!weatherData) {
    return (
      <div className="no-weather-data">
        <div className="weather-icon">
          <i className="fas fa-cloud-sun"></i>
        </div>
        <h3>No Weather Data Available</h3>
        <p>Select a location or upload data to view weather information</p>
      </div>
    )
  }

  // Only show table for date range (array), not for single day
  if (!Array.isArray(weatherData)) {
    return null
  }

  // For date range - display a table of weather data
  return (
    <div className="weather-data-range">
      <h3>Weather Data for Selected Period</h3>
      <div className="weather-table-container">
        <table className="weather-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Max Temp (°C)</th>
              <th>Min Temp (°C)</th>
              <th>Humidity Min (%)</th>
              <th>Humidity Max (%)</th>
              <th>Wind (m/s)</th>
            </tr>
          </thead>
          <tbody>
            {weatherData.map((day) => (
                <tr key={day.date}>
                  <td>{new Date(day.date).toLocaleDateString()}</td>
                  <td>{day.tempMax}</td>
                  <td>{day.tempMin}</td>
                  <td>{day.humidityMin}</td>
                  <td>{day.humidityMax}</td>
                  <td>{day.windSpeed}</td>
                </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default WeatherDataDisplay
